import l2 from './layout2.js';
import l3 from './layout3.js';
import l4 from './layout4.js';
import l5 from './layout5.js';
import l6 from './layout6.js';
import l7 from './layout7.js';
export default {
  l2: l2,
  l3: l3,
  l4: l4,
  l5: l5,
  l6: l6,
  l7: l7
};